import React from "react";
import { useLocation } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import ArdrendHeader from "../components/AllVon/VonHeader/ArdrendHeader";
import VonFooter from "../components/AllVon/VonFooter/VonFooter";

export default function MainLayoutsV2({ children, showFooter = true }) {
  const location = useLocation();
  const isCourseVideoPath = location.pathname.startsWith("/course-video");

  return (
    <div className="flex flex-col min-h-screen">
      <ArdrendHeader alwaysScrolled={true} />
      
      <main className="flex-grow">
        {children}
      </main>
      
      {showFooter && (
        <ScrollToTop
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#d15424",
            color: "#fff",
            boxShadow: "0 4px 12px rgba(209,84,36,0.3)",
            borderRadius: "50%",
            zIndex: 9999
          }}
          smooth
        />
      )}

      {showFooter && !isCourseVideoPath && <VonFooter />}
    </div>
  );
}
